// extracted by mini-css-extract-plugin
export var carrierIcon = "_wl-0";
export var carrierLogo = "_wl-1";
export var detailsSection = "_wl-2";